import { Language } from "@/components/Inputs/LanguagePicker/Language.ts";
import i18n from "i18next";

export const getLocale = (currentLang?: Language) => {
  switch (currentLang?.toLowerCase() || i18n?.language?.toLowerCase()) {
    case "en-us":
    case "enus":
    case "en-gb":
    case "engb":
      return "en";
    case "it-it":
    case "itit":
      return "it";
    case "de-de":
    case "dede":
    case "de-at":
    case "deat":
    case "de-ch":
    case "dech":
      return "de";
    case "hr-hr":
    case "hrhr":
      return "hr";
    case "sl-si":
    case "slsi":
      return "sl";
  }

  return i18n.language;
};
